var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"atom-chip-fill"},[_c('v-chip',{staticClass:"atom-chip-fill",attrs:{"label":"","small":"","color":_vm.color,"text-color":_vm.textColor}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }